import { render, staticRenderFns } from "./ImportFaturas.vue?vue&type=template&id=6153adc6&scoped=true"
import script from "./ImportFaturas.vue?vue&type=script&lang=js"
export * from "./ImportFaturas.vue?vue&type=script&lang=js"
import style0 from "./ImportFaturas.vue?vue&type=style&index=0&id=6153adc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6153adc6",
  null
  
)

export default component.exports